// [cursor 2026-06-01] S87-T2 finish-up: render typed Ask Harper context as a compact
// user-side headline/risk card above the prompt bubble. Plain text still renders as-is.
import {
  labelForKind,
  parseUserMessageText,
  type ChatContext,
} from "../../lib/chat-intents";

interface UserMessagePrimitiveProps {
  rawContent: unknown;
  createdAt?: Date;
}

function textFromRawContent(rawContent: unknown): string {
  if (typeof rawContent === "string") return rawContent;
  if (!Array.isArray(rawContent)) return "";
  return rawContent
    .map((part) => {
      if (!part || typeof part !== "object") return "";
      const p = part as { type?: string; text?: string };
      if (p.type === "text" && typeof p.text === "string") return p.text;
      return "";
    })
    .filter(Boolean)
    .join("\n\n");
}

function ContextCard({ context }: { context: ChatContext }) {
  return (
    <div
      style={{
        maxWidth: "85%",
        border:
          "1px solid color-mix(in srgb, var(--fintheon-accent) 28%, transparent)",
        borderRadius: 10,
        padding: "8px 10px",
        background:
          "color-mix(in srgb, var(--fintheon-accent) 7%, rgba(5,4,2,0.72))",
        backdropFilter: "blur(14px)",
        WebkitBackdropFilter: "blur(14px)",
      }}
    >
      <div
        style={{
          fontSize: 10,
          letterSpacing: "0.06em",
          textTransform: "uppercase",
          color: "var(--fintheon-accent)",
          opacity: 0.8,
          marginBottom: 3,
          display: "flex",
          gap: 8,
          alignItems: "center",
        }}
      >
        <span>{labelForKind(context.kind)}</span>
        {typeof context.ivScore === "number" && (
          <span style={{ fontVariantNumeric: "tabular-nums", opacity: 0.85 }}>
            IV {context.ivScore.toFixed(1)}
          </span>
        )}
      </div>
      <div style={{ fontSize: 12.5, color: "#f0ead6", lineHeight: 1.35 }}>
        {context.title}
      </div>
      {context.source && (
        <div style={{ fontSize: 10.5, color: "#a1a1aa", marginTop: 3 }}>
          {context.source}
        </div>
      )}
    </div>
  );
}

export function UserMessagePrimitive({
  rawContent,
}: UserMessagePrimitiveProps) {
  const rawText = textFromRawContent(rawContent);
  const { context, body } = parseUserMessageText(rawText);
  const bubbleText = context ? body : rawText;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        gap: 6,
      }}
    >
      {context && <ContextCard context={context} />}
      {bubbleText && (
        <div
          style={{
            maxWidth: "85%",
            border: "1px solid #3f3f46",
            borderRadius: 8,
            padding: "10px 12px",
            whiteSpace: "pre-wrap",
            fontSize: 13,
          }}
        >
          {bubbleText}
        </div>
      )}
    </div>
  );
}
